import Script from 'next/script';

import { useFeatures } from '@atc/features';

export default function CADAnalyticsScriptLoader() {

    const {
        scripts: [, { cadClarivoy }],
    } = useFeatures([
        'scripts',
    ]);

    return cadClarivoy && (
        <Script
            async
            src="https://tags-cdn.clarivoy.com/caranddriver/td/tva/loader.js"
            type="text/javascript"
        />
    );
}
